import { render, staticRenderFns } from "./postListBlock.vue?vue&type=template&id=46ea39d9&scoped=true"
import script from "./postListBlock.vue?vue&type=script&lang=js"
export * from "./postListBlock.vue?vue&type=script&lang=js"
import style0 from "./postListBlock.vue?vue&type=style&index=0&id=46ea39d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea39d9",
  null
  
)

export default component.exports